// src/redux/classSlice.js

import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import {
  get_rolebyuser,
  add_rolebyuser,
  update_rolebyuser,
  delete_rolebyuser,
  get_rolebyuser_list
} from "../Service/ApiServices.js";
import { toast } from "react-toastify";

const initialState = {
  rolebyusers: [],
  rolebyuserlist:[],
  rolebyuserfilterlist:[],
  school_id: "",
  totalPages: 0,
  pageSize: 10,
  count: 0,
  activePage: 1,
  loading: false,
  error: null,
  addLoading: false,
  IsEditing: false,
  formData: {
    name:"",
    email:"",
    mobile_no:"",
  },
};
// Async Thunks for API Calls
// export const fetchrolebyuserlist = createAsyncThunk(
//     'rolebyusertype/fetchrolebyuserlist',
//     async ({school_id,token, signal }, { rejectWithValue }) => {
//       try {
//         const response = await get_rolebyuser_list(school_id,token, signal);
//         if (response.status) {
//           return response.response;
//         } else {
//           return rejectWithValue(response.response.message);
//         }
//       } catch (error) {
//         return rejectWithValue(error.message);
//       }
//     }
//   );
//   export const fetchfilterrolebyuserlist = createAsyncThunk(
//     'rolebyusertype/fetchfilterrolebyuserlist',
//     async ({school_id,token, signal }, { rejectWithValue }) => {
//       try {
//         const response = await get_rolebyuser_list(school_id,token, signal);
//         if (response.status) {
//           return response.response;
//         } else {
//           return rejectWithValue(response.response.message);
//         }
//       } catch (error) {
//         return rejectWithValue(error.message);
//       }
//     }
//   );
// Async Thunks for API Calls
export const fetchrolebyuser = createAsyncThunk(
  "rolebyuser/fetchrolebyuser",
  async (
    {   page,
        page_size,
        role,
        school_id,
        token,
        signal},
    { rejectWithValue }
  ) => {
    try {
      const response = await get_rolebyuser(
        page,
        page_size,
        role,
        school_id,
        token,
        signal
      );
      if (response.status) {
        return response.response;
      } else {
        return rejectWithValue(response.response.message);
      }
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);
export const createrolebyuser = createAsyncThunk(
  "rolebyuser/createrolebyuser",
  async ({ data, school_id,role, token, signal }, { rejectWithValue }) => {
    try {
      const response = await add_rolebyuser(data, school_id,role, token, signal);
      if (response.status) {
        return response.response;
      } else {
        return rejectWithValue(response.response);
      }
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);



export const updaterolebyuser = createAsyncThunk(
  "rolebyuser/updaterolebyuser",
  async ({ data, token,school_id, signal }, { rejectWithValue }) => {
    try {
      const response = await update_rolebyuser(data, token,school_id, signal);
      if (response.status) {
        return response.response;
      } else {
        return rejectWithValue(response.response);
      }
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);

export const deleterolebyuser = createAsyncThunk(
  "rolebyuser/deleterolebyuser",
  async ({ids, token, signal }, { rejectWithValue }) => {
    try {
      const response = await delete_rolebyuser({ ids }, token, signal);
      if (response.status) {
        return response.response;
      } else {
        return rejectWithValue(response.response.message);
      }
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);
// rolebyuserSlice Slice
const rolebyuserSlice = createSlice({
  name: "rolebyusers",
  initialState,
  reducers: {
    setActivePage(state, action) {
      state.activePage = action.payload;
    },
    updateFormData(state, action) {
      const { name, value } = action.payload;
      state.formData[name] = value;
    },
    
    EditFormData(reduxState, action) {
      reduxState.formData = { ...action.payload };
    },
    resetFormData(state) {
      state.formData = {
        name:"",
        email:"",
        mobile_no:"",
      };
    },


    setrolebyuser(state, action) {
      state.rolebyusers = action.payload;
    },
    setIsEditing(state, action) {
      state.IsEditing = action.payload;
    },
    setPageSize(state, action) {
      state.pageSize = action.payload;
    },
    setSchoolId(state, action) {
      state.school_id = action.payload;
    },
  },


  
  extraReducers: (builder) => {
    builder
    // .addCase(fetchrolebyuserlist.fulfilled, (state, action) => {
    //     state.rolebyuserlist = action.payload.data;
    //   })
    //   .addCase(fetchrolebyuserlist.rejected, (state, action) => {
    //     state.rolebyuserlist = [];

    //   })
    //   .addCase(fetchfilterrolebyuserlist.fulfilled, (state, action) => {
    //     state.rolebyuserfilterlist = action.payload.data;
    //   })
    //   .addCase(fetchfilterrolebyuserlist.rejected, (state, action) => {
    //     state.rolebyuserfilterlist = [];
    //   })
      // Fetch Classes
      .addCase(fetchrolebyuser.pending, (state) => {
        state.loading = true;
      })
      .addCase(fetchrolebyuser.fulfilled, (state, action) => {
        state.loading = false;
        state.rolebyusers = action.payload.results;
        state.count = action.payload.count;
        state.totalPages = Math.ceil(action.payload.count / state.pageSize);
      })
      .addCase(fetchrolebyuser.rejected, (state, action) => {
        state.loading = false;
        state.rolebyusers = []
        state.error = action.payload;
      })

      // Add Class
      .addCase(createrolebyuser.pending, (state) => {
        state.addLoading = true;
      })
      .addCase(createrolebyuser.fulfilled, (state, action) => {
        state.addLoading = false;
        state.IsEditing = false;
        toast.success(action.payload.message || "Something went wrong!");
      })
      .addCase(createrolebyuser.rejected, (state, action) => {
        state.addLoading = false;
        state.error = action?.payload?.data?.message;
        const errorMessage = action?.payload?.data?.message || "Something went wrong!";
        toast.info(errorMessage);  
        state.IsEditing = false;
      })
      // Update Class
      .addCase(updaterolebyuser.pending, (state) => {
        state.addLoading = true;
      })
      .addCase(updaterolebyuser.fulfilled, (state, action) => {
        state.addLoading = false;
        state.IsEditing = false;

        toast.success(action?.payload?.message || "Something went wrong!");
      })
      .addCase(updaterolebyuser.rejected, (state, action) => {
        state.addLoading = false;
        state.error = action?.payload?.data?.message;
        state.IsEditing = false;
        const errorMessage = action?.payload?.data?.message || "Something went wrong!";
        toast.info(errorMessage); 
      })
      // Delete Class
      .addCase(deleterolebyuser.pending, (state) => {
        state.loading = true;
      })
      .addCase(deleterolebyuser.fulfilled, (state, action) => {
        state.loading = false;
        toast.success(action?.payload?.message || "Something went wrong!");
      })
      .addCase(deleterolebyuser.rejected, (state, action) => {
        state.loading = false;
        toast.info(action?.payload?.message || "Something went wrong!");
        state.error = action.payload;
      });
  },
});

// Export the actions and the reducer
export const {
  setrolebyuser,
  setActivePage,
  updateFormData,
  EditFormData,
  resetFormData,
  setIsEditing,
  setSchoolId,
  setPageSize,
} = rolebyuserSlice.actions;
export default rolebyuserSlice.reducer;
